/* eslint-disable no-useless-escape */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
// 展示图片
function showImg (img) {
  // 新建一个img标签
  const image = new Image()
  image.crossOrigin = 'Anonymous'
  image.src = img
  return image
}

// 对图片进行压缩
function compressImg (image) {
  var data
  let imageWidth = image.width * 0.8
  let imageHeight = image.height * 0.8
  var canvas = document.createElement('canvas')
  var context = canvas.getContext('2d')
  // 压缩后图片的大小
  canvas.width = imageWidth
  canvas.height = imageHeight
  context.drawImage(image, 0, 0, imageWidth, imageHeight)
  data = canvas.toDataURL('image/jpeg').replace('data:image/jpeg;base64,', '')
  var length = data.toString().length
  if (length > 1024 * 200) {
    // console.log('图片过大')
    compressImg(canvas)
  }
  return data
}

// 这里的获取exif要将图片转ArrayBuffer对象，这里假设获取了图片的baes64
// 步骤一
// base64转ArrayBuffer对象
function base64ToArrayBuffer (base64) {
  base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '')
  var binary = atob(base64)
  var len = binary.length
  var buffer = new ArrayBuffer(len)
  var view = new Uint8Array(buffer)
  for (var i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i)
  }
  return buffer
}
// 步骤二，Unicode码转字符串
// ArrayBuffer对象 Unicode码转字符串
function getStringFromCharCode (dataView, start, length) {
  var str = ''
  var i
  for (i = start, length += start; i < length; i++) {
    str += String.fromCharCode(dataView.getUint8(i))
  }
  return str
}

// 步骤三，获取jpg图片的exif的角度（在ios体现最明显）
function getOrientation (arrayBuffer) {
  var dataView = new DataView(arrayBuffer)
  var length = dataView.byteLength
  var orientation
  var exifIDCode
  var tiffOffset
  var firstIFDOffset
  var littleEndian
  var endianness
  var app1Start
  var ifdStart
  var offset
  var i
  // Only handle JPEG image (start by 0xFFD8)
  if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
    offset = 2
    while (offset < length) {
      if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
        // console.log('进入了offset')
        app1Start = offset
        break
      }
      offset++
    }
  }
  if (app1Start) {
    exifIDCode = app1Start + 4
    tiffOffset = app1Start + 10
    if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
      endianness = dataView.getUint16(tiffOffset)
      littleEndian = endianness === 0x4949
      if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
          firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
          if (firstIFDOffset >= 0x00000008) {
            ifdStart = tiffOffset + firstIFDOffset
          }
        }
      }
    }
  }

  if (ifdStart) {
    length = dataView.getUint16(ifdStart, littleEndian)
    var standalone = window.navigator.standalone
    var userAgent = window.navigator.userAgent.toLowerCase()
    var safari = /safari/.test(userAgent)
    var ios = /iphone|ipod|ipad/.test(userAgent)

    // console.log('进入了dataView', length)
    for (i = 0; i < length; i++) {
      offset = ifdStart + i * 12 + 2
      if (dataView.getUint16(offset, littleEndian) === 0x0112 /* Orientation */) {
        // 8 is the offset of the current tag's value
        offset += 8

        // Get the original orientation value
        orientation = dataView.getUint16(offset, littleEndian)

        // Override the orientation with its default value for Safari (#120)
        // if (IS_SAFARI_OR_UIWEBVIEW) {
        //  dataView.setUint16(offset, 1, littleEndian);
        // }
        if (ios) {
          if (!standalone && safari) {
            dataView.setUint16(offset, 1, littleEndian)
          } else if (standalone && !safari) {
            // standalone
          } else if (!standalone && !safari) {
            dataView.setUint16(offset, 1, littleEndian)
          };
        }
        break
      }
    }
  }
  return orientation
}

function rotateImg (img, direction, canvas, times = 1) {
  // 最小与最大旋转方向，图片旋转4次后回到原方向
  var min_step = 0
  var max_step = 3
  if (img == null) return

  // img的高度和宽度不能在img元素隐藏后获取，否则会出错
  var height = img.height
  var width = img.width
  const maxWidth = 500
  let canvasWidth = width // 图片原始长宽
  let canvasHeight = height
  const base = canvasWidth / canvasHeight
  if (canvasWidth > maxWidth) {
    canvasWidth = maxWidth
    canvasHeight = Math.floor(canvasWidth / base)
  }
  width = canvasWidth
  height = canvasHeight
  var step = 0

  if (step == null) {
    step = min_step
  }

  if (direction == 'right') {
    step += times
    // 旋转到原位置，即超过最大值
    step > max_step && (step = min_step)
  } else if (direction == 'left') {
    step -= times
    step < min_step && (step = max_step)
  } else {
    // 不旋转
    step = 0
  }

  // 旋转角度以弧度值为参数
  var degree = (step * 90 * Math.PI) / 180
  var ctx = canvas.getContext('2d')
  // console.log(degree)
  // console.log(step)
  switch (step) {
    case 1:
      // console.log('右旋转 90度')
      canvas.width = height
      canvas.height = width
      ctx.rotate(degree)
      ctx.drawImage(img, 0, -height, width, height)
      break
    case 2:
      // console.log('旋转 180度')
      canvas.width = width
      canvas.height = height
      ctx.rotate(degree)
      ctx.drawImage(img, -width, -height, width, height)
      break
    case 3:
      // console.log('左旋转 90度')
      canvas.width = height
      canvas.height = width
      ctx.rotate(degree)
      ctx.drawImage(img, -width, 0, width, height)
      break
    default:
      // 不旋转
      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0, width, height)
      break
  }

  return canvas.toDataURL('image/jpeg', 1)
}

module.exports = {
  showImg: showImg,
  compressImg: compressImg,
  getOrientation: getOrientation,
  getStringFromCharCode: getStringFromCharCode,
  base64ToArrayBuffer: base64ToArrayBuffer,
  rotateImg: rotateImg
}
